import script from "./UserPayments.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPayments.vue?vue&type=script&setup=true&lang=js"

import "./UserPayments.vue?vue&type=style&index=0&id=241af643&lang=css"

const __exports__ = script;

export default __exports__